import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrossMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCrossMedium"><Path d="M6 6L18 18M18 6L6 18" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCrossMedium;
